import React from "react";
import SidebarNavigation from "../../components/sidebar";
import { Outlet } from "react-router-dom";
import { useUser } from "../../context/UserContext";

const UserInsightsLayout = () => {
 const { isAdmin } = useUser();


  return (
    <div className="user-dashboard">
      {!isAdmin && <SidebarNavigation />}
      
      <div className="user-content" style={{ padding: isAdmin ? 0 : "40px" ,paddingLeft: isAdmin ? 0 : "85px"}}>
        <Outlet />
      </div>
    </div>
  );
};

export default UserInsightsLayout;